import * as React from "react";
const Calculation = (props) => (
  <svg
    width={33}
    height={33}
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={32.5} height={32.5} rx={10} fill="#757B8A" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.125 8.25366C9.09706 8.25366 8.25 9.10072 8.25 10.1287V23.8787C8.25 24.9066 9.09706 25.7537 10.125 25.7537H23.875C24.9029 25.7537 25.75 24.9066 25.75 23.8787V10.1287C25.75 9.10072 24.9029 8.25366 23.875 8.25366H10.125ZM10.125 9.50366H23.875C24.2321 9.50366 24.5 9.7716 24.5 10.1287V23.8787C24.5 24.2357 24.2321 24.5037 23.875 24.5037H10.125C9.76794 24.5037 9.5 24.2357 9.5 23.8787V10.1287C9.5 9.7716 9.76794 9.50366 10.125 9.50366Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 10.7539C11.3183 10.7539 10.75 11.3222 10.75 12.0039V13.8789C10.75 14.5606 11.3183 15.1289 12 15.1289H22C22.6817 15.1289 23.25 14.5606 23.25 13.8789V12.0039C23.25 11.3222 22.6817 10.7539 22 10.7539H12ZM12 12.0039H22V13.8789H12V12.0039Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.375 15.7539C15.6933 15.7539 15.125 16.3222 15.125 17.0039V18.2539C15.125 18.9356 15.6933 19.5039 16.375 19.5039H17.625C18.3067 19.5039 18.875 18.9356 18.875 18.2539V17.0039C18.875 16.3222 18.3067 15.7539 17.625 15.7539H16.375ZM16.375 17.0039H17.625V18.2539H16.375V17.0039Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.75 15.7539C20.0683 15.7539 19.5 16.3222 19.5 17.0039V22.6289C19.5 23.3106 20.0683 23.8789 20.75 23.8789H22C22.6817 23.8789 23.25 23.3106 23.25 22.6289V17.0039C23.25 16.3222 22.6817 15.7539 22 15.7539H20.75ZM20.75 17.0039H22V22.6289H20.75V17.0039Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 15.7539C11.3183 15.7539 10.75 16.3222 10.75 17.0039V18.2539C10.75 18.9356 11.3183 19.5039 12 19.5039H13.25C13.9317 19.5039 14.5 18.9356 14.5 18.2539V17.0039C14.5 16.3222 13.9317 15.7539 13.25 15.7539H12ZM12 17.0039H13.25V18.2539H12V17.0039Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.375 20.1289C15.6933 20.1289 15.125 20.6972 15.125 21.3789V22.6289C15.125 23.3106 15.6933 23.8789 16.375 23.8789H17.625C18.3067 23.8789 18.875 23.3106 18.875 22.6289V21.3789C18.875 20.6972 18.3067 20.1289 17.625 20.1289H16.375ZM16.375 21.3789H17.625V22.6289H16.375V21.3789Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 20.1289C11.3183 20.1289 10.75 20.6972 10.75 21.3789V22.6289C10.75 23.3106 11.3183 23.8789 12 23.8789H13.25C13.9317 23.8789 14.5 23.3106 14.5 22.6289V21.3789C14.5 20.6972 13.9317 20.1289 13.25 20.1289H12ZM12 21.3789H13.25V22.6289H12V21.3789Z"
      fill="white"
    />
  </svg>
);
export default Calculation;
